import React, { useRef, useEffect } from "react";
import { gsap } from "gsap";

export default function RemoveButton({
  onClick = () => {},
  tooltip = "Remove",
  size = 30,
  className = "",
  ariaLabel = "Remove item",
  label = "",
}) {
  const sizeAttr = typeof size === "number" ? `${size}px` : size;
  const tooltipRef = useRef(null);
  const btnRef = useRef(null);

  useEffect(() => {
    const tooltip = tooltipRef.current;
    const btn = btnRef.current;

    const show = () => {
      gsap.killTweensOf(tooltip); // stop any previous animation
      gsap.to(tooltip, {
        opacity: 1,
        y: 0,
        duration: 0.3,
        ease: "power2.out",
      });
    };

    const hide = () => {
      gsap.killTweensOf(tooltip);
      gsap.to(tooltip, {
        opacity: 0,
        y: 10,
        duration: 0.2,
        ease: "power2.in",
      });
    };

    btn.addEventListener("mouseenter", show);
    btn.addEventListener("mouseleave", hide);

    return () => {
      btn.removeEventListener("mouseenter", show);
      btn.removeEventListener("mouseleave", hide);
    };
  }, []);

  return (
    <div className="relative inline-flex">
      <button
        ref={btnRef}
        type="button"
        aria-label={ariaLabel}
        onClick={onClick}
        className={`group cursor-pointer outline-none flex items-center gap-2 duration-300 ${className}`}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={sizeAttr}
          height={sizeAttr}
          viewBox="0 0 24 24"
          className="stroke-gray-500 fill-none 
                     group-hover:stroke-red-600 
                     group-hover:fill-red-100 
                     duration-300"
        >
          <circle cx="12" cy="12" r="10" strokeWidth="1.5" />
          <path d="M8 8L16 16" strokeWidth="1.5" />
          <path d="M16 8L8 16" strokeWidth="1.5" />
        </svg>

        {label && (
          <span className="text-sm font-medium text-gray-700">
            {label}
          </span>
        )}
      </button>

      {/* Custom tooltip */}
      {tooltip && (
        <span
          ref={tooltipRef}
          className="absolute -top-8 left-1/2 -translate-x-1/2
                     whitespace-nowrap rounded-md bg-white text-blue-800
                     border border-blue-300 shadow-md
                     text-xs px-2 py-1 opacity-0 pointer-events-none"
        >
          {tooltip}
        </span>
      )}
    </div>
  );
}
